import { ChevronRightIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { RetailerCard } from './RetailerCard'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import 'swiper/css'
import 'swiper/css/free-mode'

export const TopRetailersSection = () => {
  const { data: retailersData } = useQuery({
    queryKey: QueryKeys.topRetailers(),
    queryFn: () => handleGetRequest('/top-retailers'),
  })
  const topRetailers = retailersData?.data || []

  if (topRetailers.length === 0) {
    return null
  }

  return (
    <div className="bg-background  py-4 border-b border-dashed border-black/50 main-container">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-lg font-extrabold text-black capitalize">Top Retailer Shops</h2>
        <Link to="/retailers" aria-label="View all retailers">
          <ChevronRightIcon className="h-6 w-6 text-secondary-600" />
        </Link>
      </div>

      <div className="py-4 flex overflow-x-auto gap-x-4 scrollbar-hide">
        {topRetailers.map((retailer) => (
          <Link to={`/retailers/${retailer.shopSlug}/products`} className="block" key={retailer.id}>
            <RetailerCard retailer={retailer} />
          </Link>
        ))}
      </div>

      <Link
        to="/retailers"
        className="mt-6 mx-4 block rounded-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary-600"
      >
        <div className="flex items-center justify-between p-4 rounded-md bg-gradient-to-r from-secondary-700 to-secondary-700">
          <div>
            <p className="text-lg font-black text-white">Don't see your favorite</p>
            <p className="text-base font-medium text-white">Find Retailer shop Now!</p>
          </div>
          <MagnifyingGlassIcon className="h-8 w-8 text-white flex-shrink-0 ml-2" />
        </div>
      </Link>
    </div>
  )
}
